import React from 'react';
import { SIGN_IN } from '../../constants';

interface ErrorProps {
    message: string;
}

const ErrorInfo: React.FC<ErrorProps> = React.memo(({ message }) => {
    return (
        <div className={`mt-24 ${message ? 'text-status-warning' : ''}`}>
            {message ? (
                message
            ) : (
                <>
                    This number is not registered with Eka.care, please{' '}
                    <span
                        onClick={() => window.open(SIGN_IN)}
                        className="text-actionPrimary bold hover:underline cursor-pointer"
                    >
                        create a doctor account
                    </span>{' '}
                    with us.
                </>
            )}
        </div>
    );
});

export default ErrorInfo;
